<script lang="ts" setup>
import type { FieldData, CheckboxOption } from '~~/server/api/forms/form'

export interface FormKitCustomOptionsProps {
    data: FieldData
}
export type OptionsObject = Record<string, string>

const props = defineProps<FormKitCustomOptionsProps>()
const model = ref<string>('')

const options = computed<OptionsObject>((): OptionsObject => {
    if (!props.data.list_options?.length) return {}
    const data: OptionsObject = {}

    props.data.list_options.forEach((option: CheckboxOption): void => {
        data[option.value.toString()] = option.label
    })

    return data
})
</script>
<template>
  <fieldset class="formkit-fieldset">
    <legend class="formkit-legend mb-4">
      {{ props.data.label }}
    </legend>
    <p
      v-if="props.data.help"
      class="formkit-help"
    >
      {{ props.data.help }}
    </p>
    <FormKit
      v-model="model"
      :options="options"
      type="radio"
      :validation="props.data.validations"
      :validation-messages="{
        required: props.data.validation_messages?.['required'] || $t('Vyberte aspoň jednu položku.'),
      }"
      :name="props.data.name"
      :delay="600"
    />
  </fieldset>
</template>
